export default __webpack_public_path__ + "assets/file-name-broken-component.0bdc856d.svg";